import ManualLinkSetup from '@monetr/interface/components/setup/manual/ManualLinkSetup';

export default function SetupManualLinkPage(): React.JSX.Element {
  return <ManualLinkSetup showLogoutFooter />;
}
